'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import invariant from 'react-utils/invariant';

const getDefaultContent = name => {
  switch (name) {
    case 'card':
      return 'summary_large_image';

    case 'site':
      return '@HubSpot';

    default:
      break;
  }

  return null;
};

const TwitterMeta = ({
  name: passedName,
  content: passedContent
}) => {
  const name = `twitter:${passedName}`;
  const content = passedContent || getDefaultContent(passedName);
  invariant(!!content, `TwitterMeta: content required to render ${name} meta tag`);
  return /*#__PURE__*/_jsx("meta", {
    name: name,
    content: content
  });
};

TwitterMeta.propTypes = {
  content: PropTypes.string,
  name: PropTypes.oneOf(['card', 'site', 'image']).isRequired
};
export default TwitterMeta;